import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp, Clock, Target } from 'lucide-react';

export function ProblemSection() {
	return (
		<section className="py-20 bg-white">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center mb-16">
					<h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
						Low to No Reply Rate? It's Not You - It's Your Cold Email Stack
					</h2>
					<p className="text-xl text-gray-600 max-w-3xl mx-auto">
						Top agencies get high inbox rates by hiring{' '}
						<strong className="text-emerald-600">
							Cold Email Infrastructure experts
						</strong>{' '}
						- specialists who manage diversified email infrastructure, multiple
						providers, constant optimization, and professional setup. We bring you the
						same{' '}
						<strong className="text-emerald-600">
							top agency grade diversified approach
						</strong>{' '}
						for less than what you'd pay Google or Outlook.
					</p>
				</div>

				<div className="grid md:grid-cols-3 gap-8">
					<Card className="border-red-200 bg-red-50">
						<CardHeader>
							<div className="h-12 w-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
								<TrendingUp className="h-6 w-6 text-red-600" />
							</div>
							<CardTitle className="text-red-900">Why Your Emails Hit Spam</CardTitle>
						</CardHeader>
						<CardContent>
							<p className="text-red-700">
								Most cold email infrastructure relies on just 2-3 providers shared
								with thousands of other cold emailers. This shared reputation means
								you get lumped in with spammers, tanking your deliverability and
								reply rates.
							</p>
						</CardContent>
					</Card>

					<Card className="border-orange-200 bg-orange-50">
						<CardHeader>
							<div className="h-12 w-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
								<Clock className="h-6 w-6 text-orange-600" />
							</div>
							<CardTitle className="text-orange-900">Technical Nightmare</CardTitle>
						</CardHeader>
						<CardContent>
							<p className="text-orange-700">
								DKIM, DMARC, SPF, domain warming, IP reputation management, etc -
								the rules keep changing overwhelming most teams. Confusion over
								outdated advice or folklore.
							</p>
						</CardContent>
					</Card>

					<Card className="border-yellow-200 bg-yellow-50">
						<CardHeader>
							<div className="h-12 w-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
								<Target className="h-6 w-6 text-yellow-600" />
							</div>
							<CardTitle className="text-yellow-900">
								Specialized Engineer Required
							</CardTitle>
						</CardHeader>
						<CardContent>
							<p className="text-yellow-700">
								You need a $120K+/year specialist who understands SMTP protocols,
								bare metal servers, DNS management, and email infrastructure. Most
								companies can't afford this level of expertise.
							</p>
						</CardContent>
					</Card>
				</div>
			</div>
		</section>
	);
}
